<template>
  <div class="cabinet_container_nav">
    <div class="nav-content">
      <div class="cabinet_container_heading">{{ heading }}</div>
      <slot name="actions" />
      <BaseButton
        v-if="showAddButton"
        class="nav-add-btn"
        :variant="buttonVariant"
        :color="buttonColor"
        :size="buttonSize"
        :icon="buttonIcon"
        :disabled="isButtonDisabled"
        @click="$emit('onAdd')"
      >
        {{ buttonText }}
      </BaseButton>
      <div class="form-group" v-if="showSearch">
        <BaseInput
          v-model="localSearchQuery"
          :fullWidth="true"
          :placeholder="searchPlaceholder"
          :size="searchSize"
          class="search-input"
          :iconPosition="searchIconPosition"
          :icon="searchIcon"
          name="search"
          @input="onSearchInput"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntityNavBar',
  emits:['onAdd', 'update:searchQuery'],
  props: {
    heading: {
      type: String,
      required: true,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: true,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    showAddButton: {
      type: Boolean,
      default: true,
    },
    initialSearchQuery: {
      type: String,
      default: '',
    },
    buttonVariant: {
      type: String,
      default: 'primary',
    },
    buttonColor: {
      type: String,
      default: 'green-5',
    },
    buttonSize: {
      type: String,
      default: 'lg',
    },
    buttonIcon: {
      type: String,
      default: 'plus-icon',
    },
    searchPlaceholder: {
      type: String,
      default: '',
    },
    searchSize: {
      type: String,
      default: 'lg',
    },
    searchIconPosition: {
      type: String,
      default: 'right',
    },
    searchIcon: {
      type: String,
      default: 'search-icon',
    },
  },
  data() {
    return {
      localSearchQuery: this.initialSearchQuery,
    };
  },
  methods: {
    onSearchInput() {
      this.$emit('update:searchQuery', this.localSearchQuery);
    },
  },
};
</script>

<style scoped>
.cabinet_container_nav {
  min-height: 55px;
  display: flex;
  align-items: center;
}

.nav-content {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.cabinet_container_heading {
  margin-right: auto;
}

.nav-add-btn {
  flex-shrink: 0;
}

.form-group {
  flex-shrink: 0;
  min-width: 240px;
}
</style>